import axios from 'axios';
import * as actionType from '../actionTypes';
import apiConstants from '../../constans/apiConstants';
import { toaster } from "../../utils/utils";
export const uploadIFSCFile = (file, cb) => dispatch => {
	dispatch({ type: actionType.LOADER_TRUE });
	console.log(file)
	axios.post(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/upload/ifsccode`, file,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
				authorization: localStorage.getItem("token"),
			}
		})
		.then(resp => {
			dispatch({ type: actionType.LOADER_FALSE });
			toaster("success", resp.data && resp.data.message);
			if (cb) {
				cb();
			}
		}).catch(err => {
			dispatch({ type: actionType.LOADER_FALSE });
			toaster("error", err.data && err.data.message)
			console.log('err', err)
		})

}
export const uploadTIDFile = (file, cb) => dispatch => {
	dispatch({ type: actionType.LOADER_TRUE });
	console.log(file)
	axios.post(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/upload/branch-tid`, file,
	{
		headers: {
			'Content-Type': 'multipart/form-data',
			authorization: localStorage.getItem("token"),
		}
	})
	.then(resp => {
		dispatch({ type: actionType.LOADER_FALSE });
		toaster("success", resp.data && resp.data.message);
		if (cb) {
			cb();
		}
	}).catch(err => {
		dispatch({ type: actionType.LOADER_FALSE });
		toaster("error", err.data && err.data.message)
		console.log('err', err)
	})
}


export const getTIDData = (pageNumber, size, value = '') => dispatch => {
	//dispatch({ type: actionType.LOADER_TRUE });
	axios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/branch-tid/list/${pageNumber}/${size}?query=${value}`,
		{
			headers: {
				"Content-Type": "application/json",
				"authorization": localStorage.getItem("token"),
			}
		})
		.then(resp => {
			//dispatch({ type: actionType.LOADER_FALSE });
			if(resp?.data?.message === "Data found"){
			  toaster("success", resp.data && resp.data.message);
			}else if(resp?.data?.message === "No data found"){
				toaster("error", resp.data && resp.data.message);
			}
			
			dispatch({
				type: actionType.IFSC_DATA,
				ifscData: resp.data.body
			})

		}).catch(err => {
			//dispatch({ type: actionType.LOADER_FALSE });
			toaster("error", err.data && err.data.message)
			console.log('err', err)
		})
}

export const uploadBulkDisable = (file, cb) => dispatch => {
	dispatch({ type: actionType.LOADER_TRUE });
	axios.put(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/disableAll/submit`, file,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
				authorization: localStorage.getItem("token"),
			}
		})
		.then(resp => {
			dispatch({ type: actionType.LOADER_FALSE });
			toaster("success", resp.data && resp.data.message);
			if (cb) {
				cb(resp);
			}
		}).catch(err => {
			dispatch({ type: actionType.LOADER_FALSE });
			toaster("error", err.data && err.data.message)
			console.log('err', err)
		})

}
export const uploadFINCAREFile = (file, fileType, proposalNo, cb) => dispatch => {
	dispatch({ type: actionType.LOADER_TRUE });
	axios.post(`${apiConstants().DOCUMENT_API_URL}api/v1/files/fincare/uploadFile?fileType=${fileType}`, file,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
				authorization: localStorage.getItem("token"),
			}
		})
		.then(resp => {
			dispatch({ type: actionType.LOADER_FALSE });
			toaster("success", resp.data && resp.data.message);
			if (cb) {
				cb();
			}
		}).catch(err => {
			dispatch({ type: actionType.LOADER_FALSE });
			toaster("error", err.data && err.data.message)
			console.log('err', err)
		})

}
export const getIFSCData = (pageNumber, size, value = '') => dispatch => {
	dispatch({ type: actionType.LOADER_TRUE });
	axios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ifsccode/list/${pageNumber}/${size}?query=${value}`,
		{
			headers: {
				"Content-Type": "application/json",
				"authorization": localStorage.getItem("token"),
			}
		})
		.then(resp => {
			dispatch({ type: actionType.LOADER_FALSE });
			toaster("success", resp.data && resp.data.message);
			dispatch({
				type: actionType.IFSC_DATA,
				ifscData: resp.data.body
			})

		}).catch(err => {
			dispatch({ type: actionType.LOADER_FALSE });
			toaster("error", err.data && err.data.message)
			console.log('err', err)
		})
}

export const getFincareData = () => async (dispatch) => {
	dispatch({ type: actionType.LOADER_TRUE });
	try {
		const { data } = await axios.get(`${apiConstants().DOCUMENT_API_URL}api/v1/files/history/uploadFile`, {
			headers: {
				"authorization": localStorage.getItem("token"),
			}
		})
		dispatch({ type: actionType.LOADER_FALSE });
		dispatch({
			type: actionType.FINCARE_HISTORY,
			payload: data.body
		})
	} catch (err) {
		console.log(`err`, err)
		dispatch({ type: actionType.LOADER_FALSE });
	}
}
